const FlyoutView = (SetDesign, $) => {
    const $flyout = $('.sd-ss-flyout').each((i, el) => {
        let initialized = false;
        const $container = $(el);
        const $toggle = $container.find('.sd-ss-flyout__button');

        const toggleFlyout = () => {
            $container.toggleClass('sd-ss-flyout--open');

            if (!initialized) {
                $container.find('.sd-ss-tabs__service-list__link').first().trigger('stream-selector-activate');
                initialized = true;
            }
        };

        $toggle.on('click', (e) => {
            e.preventDefault();
            toggleFlyout();
        });

        const escKey = 'Escape';
        $(document).on('keydown', (e) => {
            if (e.key === escKey || e.keyCode === 27) {
                $container.removeClass('sd-ss-flyout--open');
            }
        });

        $container.on('click', (e) => {
            if ($container.is(e.target)) {
                $container.removeClass('sd-ss-flyout--open');
            }
        });

        $(document).on('stream-selector-toggle-flyout', () => {
            toggleFlyout();
        });
    });
    if ($flyout.length) {
        $('a[href="#open-listen"]').on('click', (e) => {
            e.preventDefault();
            $(e.target).trigger('stream-selector-toggle-flyout');
        });
    }
};

export default FlyoutView;
